export default "__VITE_ASSET__b3a13755__"